import { Settings as LayoutSettings } from "@ant-design/pro-components";
import { AliIconfontUrl } from "./iconfontConfig";

const Settings: LayoutSettings & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: "light",
  layout: "mix",
  contentWidth: "Fluid",
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: "爆版商家后台",
  pwa: false,
  iconfontUrl: AliIconfontUrl,
};

export default Settings;
